import { UnsupportedPinSettings } from '@lessonup/pins-shared';
import { styled, TextElement } from '@lessonup/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { colorSets } from '../../foundations/colorSets/colorSets';
import { PinBackground } from '../components/PinBackground';
import { mapOriginalTypeToTranslation } from './unsupportedPin.utils';

export interface UnsupportedPinProps {
  pinSettings: UnsupportedPinSettings;
  showNotVisibleMessage?: boolean;
  isThumb?: boolean;
  children?: React.ReactNode;
}

export const UnsupportedPinStatic: React.FC<UnsupportedPinProps> = ({
  isThumb,
  pinSettings,
  showNotVisibleMessage,
  children,
}) => {
  const { t } = useTranslation('unsupportedPin');
  const originalType = mapOriginalTypeToTranslation(pinSettings.originalType, t);
  return (
    <SlideWrapper>
      <PinBackground pinType="UNSUPPORTED" settings={pinSettings} isThumb={isThumb} />
      <StyledContent>
        <TextElement textStyle="bodyText" weight="bold">
          {originalType}
        </TextElement>
        {showNotVisibleMessage && <TextElement textStyle="bodyText">{t('notVisibleWhileTeaching')}</TextElement>}
      </StyledContent>
      {children}
    </SlideWrapper>
  );
};

const SlideWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const StyledContent = styled.div`
  color: ${colorSets.unsupported.on};
  border: 2px dashed ${colorSets.unsupported.stroke};
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
